import { CalcitePanel, 
	//CalciteButton, CalciteLabel, CalciteNotice, CalciteOption, 
	//CalciteSelect, CalciteStepper, CalciteStepperItem 
} from "@esri/calcite-components-react";
import React, {useRef, useState}
//, { useEffect, useState } 
from "react";
import { connect } from "react-redux";

import { loadLayer, removeLayer } from "../../../../../Flux/thunks";
import Graphic from '@arcgis/core/Graphic';
import Field from "@arcgis/core/layers/support/Field";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import axios from "axios";


const GraphingPanel = ({loadLayerOnMap,removeLayerFromMap,arcgisMap}) => {
	
	const portalUrl = "https://www.arcgis.com";
	const [errorMessage, setErrorMessage] = useState(null);

	const fileInput = useRef();


	const generateFeatureCollection = (e) => {
		e.preventDefault();

		setErrorMessage(null);

		console.log('Default prevented...', e);
		console.log(fileInput);

		if( !fileInput.current.files ) {
			console.warn('No Files parameter....');
			setErrorMessage('No file input.');
			return false;
		} 
		
		if( fileInput.current.files.length < 1) {
			console.warn('No Files at all....');
			setErrorMessage('No file detected.');
			return false;
		} 
		
		if( fileInput.current.files.length > 1) {
			console.warn('More than one file. Only doing one at a timer....');
			setErrorMessage('Too many files.');
			return false;
		} 

		console.log('Found a file! Checking for zip...');

		const fileName = fileInput.current.value.toLowerCase();

		if (fileName.indexOf(".zip") !== -1) {
		  //is file a zip - if not notify user
		  //generateFeatureCollection(fileName);
		  _LOAD_ZIPPED_SHAPEFILE(e.target);
		} else {
		  	setErrorMessage('Add shapefile as .zip file');
		}

	}

	const _LOAD_ZIPPED_SHAPEFILE = (formElement) => {
		
		const fileName = fileInput.current.value.toLowerCase();

		let name = fileName.split(".");
		// Chrome adds c:\fakepath to the value - we need to remove it
		name = name[0].replace("c:\\fakepath\\", "");

		// define the input params for generate see the rest doc for details
		// https://developers.arcgis.com/rest/users-groups-and-items/generate.htm
		const params = {
		  name: name,
		  targetSR: arcgisMap.spatialReference,
		  maxRecordCount: 1000,
		  enforceInputFileSizeLimit: true,
		  enforceOutputJsonSizeLimit: true
		};

		// generalize features to 10 meters for better performance
		params.generalize = true;
		params.maxAllowableOffset = 10;
		params.reducePrecision = true;
		params.numberOfDigitsAfterDecimal = 0;

		const myContent = {
		  filetype: "shapefile",
		  publishParameters: JSON.stringify(params),
		  f: "json"
		};

		axios({
			method: "post",
			url: `${portalUrl}/sharing/rest/content/features/generate`,
			params: myContent,
			data: new FormData(formElement),
			headers: { "Content-Type": "multipart/form-data" },
		})
		.then( (response) => {
			console.log(response);
			_LOAD_FEATURE_COLLECTION(response.data.featureCollection);
		})
		.catch( (response) => {
			console.error(response);
		})

		
	}

	const _LOAD_FEATURE_COLLECTION = (featureCollection) => {
		console.log('This feature collection: ', featureCollection);
		let sourceGraphics = [];

		//const layers = 
		featureCollection.layers.map((layer) => {

		  const graphics = layer.featureSet.features.map((feature) => {
			return Graphic.fromJSON(feature);
		  });

		  sourceGraphics = sourceGraphics.concat(graphics);

		  const featureLayer = new FeatureLayer({
			title: `Uploaded Layer...`,
			objectIdField: "FID",
			source: graphics,
			fields: layer.layerDefinition.fields.map((field) => {
			  return Field.fromJSON(field);
			})
		  });
		  loadLayerOnMap(featureLayer);
		  return true;
		  //return featureLayer;
		  // associate the feature with the popup on click to enable highlight and zoom to
		});
		arcgisMap.goTo(sourceGraphics).catch((error) => {
			if (error.name !== "AbortError") {
			  console.error(error);
			}
		});
		/*
		arcgisMap.map.addMany(layers);
		arcgisMap.goTo(sourceGraphics).catch((error) => {
		  if (error.name !== "AbortError") {
			console.error(error);
		  }
		});
		*/

	}

	const getErrorMessage = () => {
		if( !errorMessage ) {
			return null;
		}

		return	(<p style={{color:'red'}}>{errorMessage}</p>);

	}
	
	
	return (
		<CalcitePanel>
			<div className="content-area">
				<h3>Instructions</h3>
				<p>Instructions here</p>
				<h4>Note: These layers will not be reloaded when using temporary/saved maps. </h4>
				<hr />
				{getErrorMessage()}
				<form encType="multipart/form-data" method="post" onSubmit={generateFeatureCollection}>
					<div className="field">
						<label className="file-upload">
							<span><strong>Add File</strong></span>
							<input type="file" name="file" ref={fileInput} />
						</label>
					</div>
					<button>Submit</button>
				</form>
			</div>
		</CalcitePanel>
	);
	
}
const mapStateToProps = (state) => ({
	
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	loadLayerOnMap: (layer) => {dispatch(loadLayer(layer))},
	removeLayerFromMap: (layer) => {dispatch(removeLayer(layer))},
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphingPanel);
